/**
 * Tries to set the clipboard to `detail`.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @param {'text'|'data'} type        the type of content
 * @returns {(function({detail: *}): Promise<void|null>)|*}
 */
const fn = (app, type) => async ({ detail }) => {
  try {
    return type === 'text'
      ? await navigator.clipboard.writeText(detail)
      : await navigator.clipboard.write(detail)
  } catch (e) {
    console.error(e)
  }

  return null
}
export default fn
